import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

export const AppBar = styled.div`
    background-color: ${({ theme }) => theme.colors.primary.tbcNavy};
    height: ${rem(64)};
    flex-shrink: 0;
`;

// Sticky elements stop at the scroller's padding edge; offset by this to pin flush under the app bar.
export const CONTENT_PADDING_TOP = rem(28);

export const ContentWrapper = styled.div`
    flex-grow: 1;
    padding: ${CONTENT_PADDING_TOP} ${rem(30)};
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    gap: ${rem(16)};
`;

export const Footer = styled.div`
    padding: ${rem(8)} ${rem(30)};
    margin-top: auto;
    text-align: center;
    flex-shrink: 0;
`;

export const SignOutButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-size: ${rem(13)};
    color: ${({ theme }) => theme.colors.greyscale.gray50};
    text-decoration: underline;

    &:hover {
        color: ${({ theme }) => theme.colors.primary.tbcNavy};
    }
`;
